import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { t } from '../../i18n/translate.js';
import Button from '../../components/Button/Button.js';
import styles from './Alert.module.scss.js';

/* eslint-disable react/require-default-props */
var Alert = function Alert(_ref) {
  var onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel,
    children = _ref.children,
    title = _ref.title,
    _ref$cancelText = _ref.cancelText,
    cancelText = _ref$cancelText === void 0 ? t('MPLIB_CANCEL') : _ref$cancelText,
    _ref$acceptText = _ref.acceptText,
    acceptText = _ref$acceptText === void 0 ? t('MPLIB_ACCEPT') : _ref$acceptText,
    testDataId = _ref.testDataId;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.contentWrapper,
    id: testDataId
  }, /*#__PURE__*/React.createElement("h1", {
    className: classNames('title', styles.title)
  }, title), /*#__PURE__*/React.createElement("div", null, children), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonBar
  }, /*#__PURE__*/React.createElement(Button, {
    dataTestId: "".concat(testDataId, "_cancel"),
    text: cancelText,
    onClick: onCancel,
    className: styles.optionButton,
    flat: true,
    cancel: true
  }), /*#__PURE__*/React.createElement(Button, {
    dataTestId: "".concat(testDataId, "_ok"),
    text: acceptText,
    onClick: onConfirm,
    className: styles.optionButton,
    flat: true
  })));
};
Alert.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  cancelText: PropTypes.string,
  acceptText: PropTypes.string,
  testDataId: PropTypes.string.isRequired
};

export { Alert as default };
